import { useState } from "react"

function useToggle(initialValue = false) {

  const [state, setState] = useState(initialValue)

  function toggle(newStateValue?: boolean) {
    if (newStateValue === undefined)
      setState(prevToggle => !prevToggle)
    else
      setState(newStateValue)
  }

  return [state, toggle] as const
}
export default useToggle